import React from 'react'
import { useTranslation } from 'react-i18next'
import { Languages, FileText } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTranslationToggle } from '@/contexts/TranslationContext'

export function TranslationToggle() {
    const { t } = useTranslation()
    const { isTranslationEnabled, toggleTranslation, isTranslating } = useTranslationToggle()

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="sm"
                    className="flex items-center gap-1 h-8 px-2"
                    title={t('header.translationMode')}
                    disabled={isTranslating}
                >
                    {isTranslationEnabled ? (
                        <Languages className="h-4 w-4" />
                    ) : (
                        <FileText className="h-4 w-4" />
                    )}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem
                    onClick={() => {
                        if (!isTranslationEnabled) {
                            toggleTranslation()
                        }
                    }}
                    className="flex items-center gap-2"
                >
                    <Languages className="h-4 w-4" />
                    <div>
                        <div className="font-medium">{t('header.translate')}</div>
                        <div className="text-xs text-muted-foreground">
                            {t('header.translateDescription')}
                        </div>
                    </div>
                    {isTranslationEnabled && (
                        <div className="ml-auto h-2 w-2 rounded-full bg-green-500" />
                    )}
                </DropdownMenuItem>
                <DropdownMenuItem
                    onClick={() => {
                        if (isTranslationEnabled) {
                            toggleTranslation()
                        }
                    }}
                    className="flex items-center gap-2"
                >
                    <FileText className="h-4 w-4" />
                    <div>
                        <div className="font-medium">{t('header.source')}</div>
                        <div className="text-xs text-muted-foreground">
                            {t('header.sourceDescription')}
                        </div>
                    </div>
                    {!isTranslationEnabled && (
                        <div className="ml-auto h-2 w-2 rounded-full bg-blue-500" />
                    )}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
